module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-notice jin-side-notice"
  }, [_c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('h3', {
    staticClass: "jin-side-notice__h"
  }, [_vm._v("\n    《金十交易现场》英文-中文同声传译\n    ")]), _vm._v(" "), (_vm.countdownTime && !_vm.isLive) ? _c('div', {
    staticClass: "jin-side-notice__countdown"
  }, [_c('icon', {
    attrs: {
      "type": "countdown"
    }
  }), _vm._v(" "), _c('span', [_vm._v("距离下一个节目直播还有 ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.countdownTime))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "jin-side-notice__time"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title is-inline"
  }, [_vm._v("直播时间")]), _vm._v(" "), (_vm.datas.date) ? _c('p', [_vm._v(_vm._s(_vm._f("dateFormat")(_vm.datas.date, 'yyyy年MM月dd日hh:mm:ss')) + "（北京时间）")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__figure"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("本次讲话出场人物")]), _vm._v(" "), _c('ul', {
    staticClass: "jin-side-notice__list"
  }, _vm._l((_vm.datas.guest), function(name, index) {
    return _c('li', {
      key: index,
      staticClass: "jin-side-notice__imgText is-inline"
    }, [_c('img', {
      attrs: {
        "src": ("//tv.jin10.com/assets/img/trading/figure/" + name + ".jpg"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(name))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__intro"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("当前节目主题介绍")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.datas.memo))])])]), _vm._v(" "), (_vm.datas.interpreter) ? _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__figure"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("Ta正在为您同传")]), _vm._v(" "), _c('ul', {
    staticClass: "jin-side-notice__list"
  }, _vm._l((_vm.datas.interpreter), function(name, index) {
    return _c('li', {
      key: index,
      staticClass: "jin-side-notice__imgText is-inline"
    }, [_c('img', {
      attrs: {
        "src": ("//tv.jin10.com/assets/img/trading/interpreter/" + name + ".png"),
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(name))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__intro"
  }, [_c('h4', {
    staticClass: "jin-side-notice__title"
  }, [_vm._v("栏目介绍")]), _vm._v(" "), _c('p', [_vm._v("我们是金十小黑屋同传，致力于为您提供美联储主席鲍威尔、欧洲央行行长德拉基、“债王”格罗斯、“股神”巴菲特等大佬讲话的现场直播。交易世界，分秒必争，来交易现场体验没有时差阻隔、没有语言障碍的同传直播。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jin-side-notice__item"
  }, [_c('div', {
    staticClass: "jin-side-notice__qrcode"
  }, [_c('p', [_vm._v("请关注我们的公众号（仅面向专业用户）")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//tv.jin10.com/assets/img/trading/jiaoyuwechat.jpg",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9c0c5244","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/tv/modules/Content/src/TradingNotice.vue
// module id = IJUa
// module chunks = 2 3 4 6 7 8 9